@layer module {
.recurring-payments-filter {
            border-bottom: 1px solid;
    }
} // layer module










@layer app {
.recurring-payments-filter {
            padding: $size-12 $size-16;
    }

.recurring-payments-filter {
            border-bottom-color: var(--border-default);
    }
} // layer app










@layer context {
.recurring-payments-reset {
            min-width: 0;
            padding: 0 $size-8;
            border-color: transparent;
            background: transparent;
            box-shadow: none;
            color: var(--color-brand);
    }

.recurring-payments-reset:hover:not(:disabled) {
            background: var(--color-brand-wash);
    }
} // layer context
